// Where to send a user after signing in, from a ?next= parameter. Only a
// same-origin path is accepted (not //host, not back to /login), so a crafted
// link can't bounce the user to another site.
export function sanitizeNext(next: string | null, fallback = '/assets'): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\') || next.startsWith('/login'))
    return fallback;
  return next;
}

// The /login URL that comes back to `path` after signing in.
export function loginPathFor(path: string): string {
  return `/login?next=${encodeURIComponent(path)}`;
}
